import styled from "styled-components";

import { JointAcademyAvatar } from "./JointAcademyAvatar";

export type AuthorType = {
  avatar: React.ReactNode;
  name: string;
};

interface Props {
  author: AuthorType | undefined;
}

export const Author: React.FC<Props> = ({ author }) => {
  const { avatar, name } = author || {};

  return (
    <Container>
      {avatar || <JointAcademyAvatar />}
      <Name>{name || "Joint Academy"}</Name>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Name = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.black};
`;
